import GenericModel from '../../generic-model';
import { SignConstructionMaterialType } from './sign-construction-material-type';

export class SignConstructionRequirement extends GenericModel {
  signConstructionMaterialType: SignConstructionMaterialType;
  signConstructionMaterialLength: number;
  description: string;
  amount: number;
}
